const config = {
	basePath: '',
};

export default config;



// WEBPACK FOOTER //
// ./js/webpack/config.local.js